import { Transform } from "class-transformer";
import { parseApiDate } from "@/utils/dates/dateFormats";

export class VersionDto {
  version: string;

  @Transform(({ value }) => parseApiDate(value))
  date: Date;
}
